export const emptyToNull = (value: string): string | null =>
  value && value.trim() !== '' ? value : null;

export const toNumberOrNull = (value: string): number | null => {
  if (!value || value.trim() === '') return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const toIntOrNull = (value: string): number | null => {
  if (!value || value.trim() === '') return null;
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const toDateInput = (value: unknown): string =>
  value ? String(value).slice(0, 10) : '';

export const numberToString = (value: unknown): string =>
  value === null || value === undefined ? '' : String(value);

export const toIntOrZero = (value: string): number => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};
